import React from 'react';
import { Link } from 'react-router-dom';



export const ResultComponent = () => {
  return (
    <div className='p-5'>
      {
        <h1 className='display-6 text-muted'>
          Thanks for participating... <br />
          We will contact you based on the test result.</h1>
      }
      <div>
        <label>Goto</label>
        <Link style={{ "marginTop": "-4px" }} className='btn text-primary' to='/'>Home Page</Link>
      </div>

      <br /> <br /> <br /> <br /> <br /> <br /><br />
    </div>
  )
}
